module.exports = __webpack_public_path__ + "static/media/sectronpjqr.0d82dd13.png";